import { useQuery } from '@tanstack/react-query';
import { STALE_MS } from '../config';
import { getWorkspaces } from '../endpoints';
import { queryKeys } from '../queryKeys';
import { queryRetry } from './shared';

export function useWorkspaces(options: { readonly enabled?: boolean } = {}) {
  return useQuery({
    queryKey: queryKeys.workspaces(),
    queryFn: ({ signal }) => getWorkspaces(signal),
    enabled: options.enabled ?? true,
    staleTime: STALE_MS.workspaces,
    retry: queryRetry,
  });
}
